<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :filter="filter"
  >
    <template v-slot:item="{ parent, item, on, attrs }">
      <v-list-item v-bind="attrs" v-on="on" two-line>
        <v-list-item-avatar v-if="avatar">
          <img :src="(item[itemAvatar] === null) ? '/static/default_avatar.png' : `/api/v1/uploads/avatar/${item[itemAvatar]}`">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item[parent.itemText]"></v-list-item-title>
          <v-list-item-subtitle v-html="item[itemDesc]"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-if="tableView" v-slot:append-outer>
      <v-btn icon @click="clickTable" color="red"><v-icon>mdi-view-grid</v-icon></v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'v-combo-multisearch',
  props: {
    itemDesc: {
      type: String,
      default: 'description'
    },
    itemAvatar: {
      type: String,
      default: 'avatar'
    },
    avatar: Boolean,
    tableView: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  created () {
  },
  mounted () {
  },
  methods: {
    filter (item, queryText, itemText) {
      return (
        item[this.$attrs['item-text']].toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || (
          item[this.itemDesc] &&
          item[this.itemDesc].toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        )
      )
    },
    clickTable () {
      this.$emit('showTable')
    }
  }
}
</script>

<style scoped>

</style>
